module.exports = __webpack_public_path__ + "assets/img/5d25-ni.svg";